import { jsx } from "react/jsx-runtime";
function GoAIcon({
  type,
  theme,
  size,
  inverted,
  fillColor,
  opacity,
  title,
  ariaLabel,
  mt,
  mr,
  mb,
  ml,
  testId
}) {
  return /* @__PURE__ */ jsx(
    "goa-icon",
    {
      type,
      theme,
      size,
      inverted,
      fillcolor: fillColor,
      opacity,
      title,
      arialabel: ariaLabel,
      mt,
      mr,
      mb,
      ml,
      testid: testId
    }
  );
}
export {
  GoAIcon as G
};
//# sourceMappingURL=icon-DgSW1II3.mjs.map
